/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CommonCursorPaginationResponse interface.
 */
export function instanceOfCommonCursorPaginationResponse(value) {
    if (!('pageSize' in value) || value['pageSize'] === undefined)
        return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined)
        return false;
    if (!('hasNextPage' in value) || value['hasNextPage'] === undefined)
        return false;
    if (!('hasPreviousPage' in value) || value['hasPreviousPage'] === undefined)
        return false;
    if (!('startCursor' in value) || value['startCursor'] === undefined)
        return false;
    if (!('endCursor' in value) || value['endCursor'] === undefined)
        return false;
    return true;
}
export function CommonCursorPaginationResponseFromJSON(json) {
    return CommonCursorPaginationResponseFromJSONTyped(json, false);
}
export function CommonCursorPaginationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pageSize': json['page_size'],
        'totalPages': json['total_pages'],
        'hasNextPage': json['has_next_page'],
        'hasPreviousPage': json['has_previous_page'],
        'startCursor': json['start_cursor'],
        'endCursor': json['end_cursor'],
    };
}
export function CommonCursorPaginationResponseToJSON(json) {
    return CommonCursorPaginationResponseToJSONTyped(json, false);
}
export function CommonCursorPaginationResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'page_size': value['pageSize'],
        'total_pages': value['totalPages'],
        'has_next_page': value['hasNextPage'],
        'has_previous_page': value['hasPreviousPage'],
        'start_cursor': value['startCursor'],
        'end_cursor': value['endCursor'],
    };
}
